import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReturn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 16,
		transform: "matrix(1 0 0 -1 0 32)",
		fill: "#F7F7F7"
	}), /* @__PURE__ */ _jsx("g", {
		opacity: .7,
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.8367 19.8215L12.6582 21L7.66672 16.0085L7.67699 15.9982L7.66672 15.988L12.6582 10.9965L13.8367 12.175L10.8452 15.1665H24.67V16.8332H10.8484L13.8367 19.8215Z",
			fill: "#414149"
		})
	})]
});
export { SvgReturn as ReactComponent };
